import { Checkbox } from "@/components/ui/checkbox";

interface TestCategoryCardProps {
  id: string;
  name: string;
  description: string;
  isSelected: boolean;
  onToggle: () => void;
  disabled?: boolean;
  variant?: "core" | "suggested" | "custom";
  reason?: string;
}

export const TestCategoryCard = ({
  id,
  name,
  description,
  isSelected,
  onToggle,
  disabled = false,
  variant = "core",
  reason,
}: TestCategoryCardProps) => {
  const getBadge = () => {
    if (variant === "suggested") {
      return (
        <span className="inline-flex items-center px-2 py-0.5 text-xs font-medium bg-gray-100 text-gray-600 rounded-full">
          Recommended
        </span>
      );
    }
    if (variant === "custom") {
      return (
        <span className="inline-flex items-center px-2 py-0.5 text-xs font-medium bg-gray-100 text-gray-600 rounded-full">
          Custom
        </span>
      );
    }
    return null;
  };

  return (
    <div
      className={`p-4 rounded-xl border-2 transition-all ${
        isSelected
          ? "border-genie-primary bg-genie-primary/5 shadow-sm"
          : "border-gray-200 hover:border-gray-300 bg-white hover:shadow-sm"
      } ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
      onClick={() => !disabled && onToggle()}
    >
      <div className="flex items-start gap-3">
        <Checkbox
          checked={isSelected}
          disabled={disabled}
          onCheckedChange={() => onToggle()}
          className="mt-1"
        />
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="font-semibold text-sm text-gray-900">{name}</span>
            {getBadge()}
          </div>
          <p className="text-xs text-gray-500 mt-1 line-clamp-2">{description}</p>
          {reason && variant === "suggested" && (
            <p className="text-xs text-gray-500 mt-1.5 italic">{reason}</p>
          )}
        </div>
      </div>
    </div>
  );
};
